import { render, staticRenderFns } from "./index.vue?vue&type=template&id=498196cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=498196cc&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=498196cc&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498196cc",
  null
  
)

export default component.exports